/**
 * Chat Input Renderer
 * Template function for rendering input area
 */

import { html, type TemplateResult } from 'lit';

/**
 * Renders the input area with send button
 */
export function renderInputArea(
  inputValue: string,
  onInput: (e: Event) => void,
  onKeyPress: (e: KeyboardEvent) => void,
  onSend: () => void,
  isResponding: boolean = false,
  hasEstablishedSession: boolean = false
): TemplateResult {
  return html`
    <div class="input-area">
      <!-- <div class="input-icon"></div> -->
      <div class="input-wrapper">
        <textarea
          class="message-input"
          rows="1"
          enterkeyhint="send"
          placeholder="Escreva a sua mensagem..."
          autofocus
          autocomplete="off"
          name="mariana-chat-message"
          .value=${inputValue}
          @input=${onInput}
          @keypress=${onKeyPress}
        ></textarea>
        <!-- <div class="emoji-icon"></div> -->
      </div>
      <button
        class="send-button"
        @click=${onSend}
        ?disabled=${!hasEstablishedSession || !inputValue.trim() || isResponding}
      >
        <div class="send-icon"></div>
      </button>
    </div>
  `;
}
